import PaymentCodesService from './payment-codes-service';
import PaymentCodesContainerModule from './payment-codes-container/payment-codes-container-module';
import NonEditablePaymentCodesModule from './non-editable-payment-codes/non-editable-payment-codes-module';

const MODULE_NAME = 'App.Trip.payment-codes';
const module = angular.module(MODULE_NAME, [
    PaymentCodesContainerModule,
    NonEditablePaymentCodesModule,
])
    .service('paymentCodesService', PaymentCodesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-module.js